import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import RightArrow from '../../components/SVG';
import SingleCourse from '../../components/Course';
import { programPath } from '../../data';
import { useCollections } from '../../lib/api/collections';

import { programImages, sanasaAvatar40 as sanasaAvatar } from '../../data/images';

const teaser = [
  { slug: 'certification-on-director-board-competency', delay: '.3s' },
  { slug: 'diploma-in-human-resource-management', delay: '.5s' },
  { slug: 'higher-diploma-in-micro-finance', delay: '.7s' },
];

const Course = () => {
  const { programs } = useCollections('programs');
  if (!programs) return null;

  return (
    <div
      id="it-course"
      className="it-course-area ed-course-bg ed-course-style-3 p-relative pt-120 pb-90"
    >
      <div className="container">
        <div className="ed-course-title-wrap mb-65">
          <div className="row align-items-center">
            <div className="col-xl-6">
              <SectionTitle
                itemClass="it-course-title-box"
                subTitleClass="ed-section-subtitle"
                subTitle="Our Programs"
                titleClass="ed-section-title"
                title="Learn A Skill That Helps You Work And Grow"
              />
            </div>
            <div className="col-xl-6">
              <div className="ed-course-button text-lg-end">
                <Link className="ed-btn-square orange" to="/programs">
                  See All Programs
                  <i>
                    <RightArrow />
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {teaser.map(({ slug, delay }) => {
            const p = programs.find((x) => x.id === slug);
            if (!p) return null;
            return (
              <div
                key={slug}
                className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay={delay}
              >
                <SingleCourse
                  to={programPath(p)}
                  courseImage={programImages(p).card}
                  thumbText={p.tag}
                  price={p.price}
                  title={p.cardTitle}
                  lessonCount={p.schedule}
                  duration={p.duration}
                  studentCount={p.language}
                  authorAvatar={sanasaAvatar}
                  authorName={p.unit}
                  btnText="Enroll"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Course;
